import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarHiddenLeftWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM6 8V16H8V8H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenLeftWide;
